import React, { useCallback, Fragment } from 'react'
import { Link } from 'react-router-dom'
import { Flex } from 'reflexbox'

import { Text } from 'components/Typography'
import { ChevronRight } from 'components/Icons'
import { colors, fontWeights } from 'styles/theme'

const Breadcrumb = ({ children }) => {
  const isLastElement = useCallback(index => children.length - 1 === index, [children])

  return (
    <Flex mb={20}>
      {children &&
        children.map(({ link, label }, index) => (
          <Fragment key={index}>
            {link ? (
              <Fragment>
                <Text color={colors.blues.A800} as={Link} to={link}>
                  {label}
                </Text>
                {!isLastElement(index) && <ChevronRight color={colors.blues.A800} />}
              </Fragment>
            ) : (
              <Text color={colors.blues.A800} fontWeight={fontWeights.bold}>
                {label}
              </Text>
            )}
          </Fragment>
        ))}
    </Flex>
  )
}

export default Breadcrumb
